<template>

    <header class="text-white px-4 pt-5 flex items-center justify-between relative">

    <a id="toggle-nav" @click="openMenu">
        <i class="inline-block h-8 w-8 mask mask-menu bg-white"></i>
      <span></span>
      <div v-if="badgeCount > 0" class="indicator">
        <div class="noti_count" role="status">{{ badgeCount }}</div>
      </div>
    </a>

    <span v-if="$route.name === 'home'">
        <img :src="logoUrl" alt="Fi360" class="h-14" />
    </span>

    <h1 v-if="$route.name !== 'home' && $route.name !== 'support'" class="flex items-center gap-2 mb-5" >
        <i :class="iconHeaderClass" class="inline-block"></i>
        <span class="whitespace-nowrap"><slot></slot></span>
    </h1>
    <h1 v-if="$route.name === 'support'" class="flex items-center gap-2 mb-5" >
        <span class="whitespace-nowrap"><slot></slot></span>
    </h1>


    <notif-bar v-if="$route.name === 'home' "></notif-bar>

  </header>

</template>

<script>

import NotifBar from './NotifBar.vue'
import Config from '../../js/config'


if (Config.urlAPI !== 'https://api.fi360.fr') {
    document.write(`
        <div style="
            position: fixed;
            top: 12px;
            left: 66%;
            transform: translateX(-50%);
            z-index: 2147483647;
            background: #c31616;
            color: #fff;
            padding: 6px 12px;
            border-radius: 9999px;
            font-weight: 700;
            font-family: Arial, Helvetica, sans-serif;
            letter-spacing: .5px;
            text-transform: uppercase;
        ">
            DEV
        </div>
    `);

}


export default {

  data() {
    return {
      logoUrl: require('@/img/logo-fi360-nomadia-blanc.svg')
    }
  },

  methods: {
    openMenu : function () {
      document.getElementById('menu').className += ' open';
    }
  },

  props: {
    icon: {
      type: String,
      required: false,
      default: 'home'
    }
  },

  computed: {
    iconHeaderClass: function(){
      return '"mask mask-' + this.icon + ' bg-white inline-block h-8 w-8 mr-3"';
    },
    badgeCount() {
      return this.$root.badgeCount;
    }
  },

  components: {
    NotifBar
  }
}

</script>
<style>
.indicator {
  position: absolute;
  top: -10px; /* Adjusted for better vertical positioning */
  right: -10px; /* Adjusted for better horizontal positioning */
  width: 20px;
  height: 20px;
  background-color: red;
  border: 3px solid white;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.noti_count {
  font-family: 'Montserrat', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
  color: aliceblue;
  font-weight: 700;
  font-size: 12px;
}
</style>


// WEBPACK FOOTER //
// Header.vue?04cacbc0